import { useContext, useEffect, useState, useCallback } from "react";
import { toDateString, toDateTimeString } from "../date_utils";
import { idString } from "../db_utils";
import { TableDef } from "../table_def";
import { Context } from "../context";
import { useSearchInput } from "../components/search_input";
import { SimpleGrid } from "../components/simple_grid";
import * as FC from "@fluentui/react-components";
import { apiClient } from "./api";

export const turbine_searchable_columns = [
    "seq",
    "name",
    // "model.name",
    // "description",
];

export const listTurbines = async (_, filter = null, fieldId = null) => {
    try {
        const params = {};
        if (fieldId) {
            // Extract the numeric ID if it's an object
            const id = typeof fieldId === 'object' ? fieldId.id : fieldId;
            params.fieldId = id;
        }
        if (filter) {
            params.search = filter;
        }
        
        console.log("Loading turbines with params:", params);
        const response = await apiClient.getTurbines(params);
        
        // Apply client-side filtering if needed
        let turbines = response || [];
        if (filter && filter.trim()) {
            const filterLower = filter.toLowerCase();
            turbines = turbines.filter(turbine => 
                turbine_searchable_columns.some(column => 
                    turbine[column]?.toString().toLowerCase().includes(filterLower)
                )
            );
        }
        
        console.log("turbines:", turbines);
        return turbines;
    } catch (error) {
        console.error("Error loading turbines:", error);
        return [];
    }
};

export const TurbineSelector = ({ defaultValue = null, onChange }) => {
    const { apiClient, currentField } = useContext(Context);
    const { filter, SearchInput } = useSearchInput();
    const [items, setItems] = useState([]);
    const [open, setOpen] = useState(false);
    const [text, setText] = useState(defaultValue || "选择风机");

    const loadItems = useCallback(async () => {
        const items = await listTurbines(null, filter, currentField);
        setItems(items);
    }, [filter, currentField]);

    const onSelectionChange = (evt, data) => {
        setOpen(false);
        let selectedItem = Array.from(data.selectedItems)[0];
        let item = items.find((item) => idString(item.id) === selectedItem);
        if (item) {
            let text = `${item.seq}(${item.name})/${item.field_item?.name || item.fieldName || ''}`;
            setText(text);
        }
        onChange(selectedItem);
    };

    useEffect(() => {
        if (!apiClient) {
            return;
        }
        loadItems();
    }, [apiClient, loadItems]);

    const columns = [
        TurbineDef.createTableColumn("seq"),
        TurbineDef.createTableColumn("name"),
        // TurbineDef.createTableColumn("model"),
        TurbineDef.createTableColumn("field_item"),
        // TurbineDef.createTableColumn("description"),
    ];
    return (
        <FC.Menu open={open} onOpenChange={(evt, data) => setOpen(data.open)}>
            <FC.MenuTrigger>
                <FC.MenuButton>{text}</FC.MenuButton>
            </FC.MenuTrigger>
            <FC.MenuPopover style={{ width: "100%", maxWidth: "400px" }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 10,
                    }}
                >
                    <SearchInput />
                    <SimpleGrid
                        items={items}
                        columns={columns}
                        selectionMode="single"
                        onSelectionChange={onSelectionChange}
                        getRowId={(item) => idString(item.id)}
                    />
                </div>
            </FC.MenuPopover>
        </FC.Menu>
    );
};

export const TurbineDef = new TableDef("turbine", {
    seq: {
        label: "风机编号",
    },
    name: {
        label: "风机名称",
    },
    model: {
        label: "风机型号",
        display: (item) => item.model?.seq,
    },
    field_item: {
        label: "风场",
        display: (item) => item.field_item?.name,
    },
    installed_at: {
        label: "安装日期",
        display: (item) => toDateString(item.installed_at),
    },
    updated_at: {
        label: "更新时间",
        display: (item) => toDateTimeString(item.updated_at),
    },
    description: {
        label: "备注",
    },
});

// TurbineDef.prototype = {
//     /**
//      * @returns {import("@fluentui/react-components").CreateTableColumnOptions}
//      */
//     createTableColumn(key) {
//         let field = this[key];
//         if (!field) {
//             throw `table Turbine has no column: ${key}!`;
//         }
//         const renderHeaderCell = () => field.label;

//         const renderCell = (item) => (
//             <FC.TableCellLayout>{item[key]}</FC.TableCellLayout>
//         );

//         return FC.createTableColumn({
//             columnId: key,
//             renderHeaderCell,
//             renderCell,
//         });
//     },
// };
